import { PAYRUNS_FETCHING, PAYRUNS_FAILED, PAYRUNS_SUCCESS } from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case PAYRUNS_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case PAYRUNS_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case PAYRUNS_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
};
